import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { LoyaltyActions, LoyaltyModels } from "gyg_common";
import { RewardsModal } from "views/components/Rewards/RewardsModal/RewardsModal";

interface IRewardsModalContainerProps extends LoyaltyModels.IRewards {
  rewardsDetailModalVisible: boolean;
  closeModal: () => void;
}

export const RewardsModalContainer: React.FC<IRewardsModalContainerProps> = ({
  closeModal,
  rewardsDetailModalVisible,
  ...reward
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const openTermsAndConditions = () => {
    if (reward.terms.url) {
      window.open(reward.terms.url, "_blank");
    }
  };

  const onOrderNowPressed = () => {
    dispatch(LoyaltyActions.updateActiveReward(reward));

    if (reward.link) {
      window.open(reward.link, "_blank");
    }
  };

  return (
    <RewardsModal
      {...reward}
      closeModal={closeModal}
      mainButtonName={t("CheckoutPayment:orderBtnLabel")}
      rewardsDetailModalVisible={rewardsDetailModalVisible}
      onMainButtonPressed={onOrderNowPressed}
      openTermsAndConditions={openTermsAndConditions}
    />
  );
};

export default RewardsModalContainer;
